/**
 * 골든 이벤트 시스템 (PLAN.md 기반)
 */

export interface GoldenEventConfig {
  id: string;
  name: string;
  probability: number; // 0-1
  effect: {
    type: 'instant' | 'duration';
    value: number;
    duration?: number; // seconds
  };
  description: string;
}

export const GOLDEN_EVENTS: GoldenEventConfig[] = [
  {
    id: 'golden_coin',
    name: '골든 코인',
    probability: 0.4,
    effect: {
      type: 'instant',
      value: 777 // CPS × 777
    },
    description: 'CPS × 777을 즉시 획득'
  },
  {
    id: 'lucky_golden',
    name: '럭키 골든',
    probability: 0.25,
    effect: {
      type: 'duration',
      value: 7, // CPS × 7
      duration: 15
    },
    description: '15초간 CPS ×7'
  },
  {
    id: 'click_frenzy',
    name: '클릭 프렌지',
    probability: 0.2,
    effect: {
      type: 'duration',
      value: 10, // 탭 파워 × 10
      duration: 30
    },
    description: '30초간 탭 파워 ×10'
  },
  {
    id: 'production_boost',
    name: '생산 부스트',
    probability: 0.1,
    effect: {
      type: 'duration',
      value: 5, // 모든 생산 × 5
      duration: 30
    },
    description: '30초간 모든 생산 ×5'
  },
  {
    id: 'mega_jackpot',
    name: '메가 잭팟',
    probability: 0.05,
    effect: {
      type: 'instant',
      value: 10 // 현재 코인 × 10
    },
    description: '현재 코인 ×10'
  }
];

export const GOLDEN_CONFIG = {
  minInterval: 5 * 60 * 1000, // 5분
  maxInterval: 10 * 60 * 1000, // 10분
  averageInterval: 7 * 60 * 1000, // 7분
  displayDuration: 15000, // 15초
  adMultiplier: 2, // 광고 시청 시 효과 2배
  adDurationMultiplier: 2 // 광고 시청 시 지속시간 2배
};

/**
 * 골든 이벤트 출현 주기 배율 (업그레이드/버프 기반)
 * 작을수록 자주 출현
 */
export function getGoldenIntervalMultiplier(state: {
  purchasedUpgrades: string[];
  prestige: { buffs: Record<string, number> };
  prestige2: { purchasedUpgrades: string[] };
}): number {
  let mult = 1;
  if (state.purchasedUpgrades.includes('up_global_golden2')) mult *= 0.5;
  if (state.prestige2.purchasedUpgrades.includes('meta_golden_boost')) mult *= 0.5;
  const goldenBuffLevel = state.prestige.buffs['buff_golden'] || 0;
  if (goldenBuffLevel > 0) mult *= 1 / (1 + goldenBuffLevel * 0.02);
  return mult;
}
